abstract class EntityShared {
    abstract entityKind: 'not loaded' | 'loading' | 'loaded';
}

export class EntityNotLoaded extends EntityShared {
    readonly entityKind = 'not loaded';

    static readonly instance = new EntityNotLoaded();
}

export class EntityLoading extends EntityShared {
    readonly entityKind = 'loading';

    static readonly instance = new EntityLoading();
}

class InternalEntityLoaded extends EntityShared {
    readonly entityKind = 'loaded';
}

export type EntityLoaded<T> = T & InternalEntityLoaded;

export type Entity<T> = EntityNotLoaded | EntityLoading | EntityLoaded<T>;

export const isEntityLoading = <T>(data: Entity<T>): data is EntityLoading => {
    return data.entityKind === 'loading';
};

export const isEntityNotLoaded = <T>(data: Entity<T>): data is EntityNotLoaded => {
    return data.entityKind === 'not loaded';
};

export const isEntityLoaded = <T>(data: Entity<T>): data is EntityLoaded<T> => {
    return data.entityKind === 'loaded';
};

export const createLoadedEntity = <T>(entity: T): EntityLoaded<T> => {
    const loaded = new InternalEntityLoaded();

    return {
        ...loaded,
        ...entity,
    };
};
